// extracted by mini-css-extract-plugin
module.exports = {"password":"styles_password__2r8G_","inputPassword":"styles_inputPassword__3oFNW"};